import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, signInWithCustomToken } from 'firebase/auth';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Validate required environment variables
const requiredEnvVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_APP_ID'
];

for (const envVar of requiredEnvVars) {
    if (!import.meta.env[envVar]) {
        throw new Error(`Missing required environment variable: ${envVar}`);
    }
}

let app;
try {
    app = initializeApp(firebaseConfig);
} catch (error) {
    console.error('Error initializing Firebase:', error);
    throw error;
}

export const auth = getAuth(app);

/**
 * Sign in with a custom token
 * @param {string} customToken - The custom token from your backend
 * @returns {Promise<import('firebase/auth').UserCredential>}
 */
export const signInWithCustomTokenHelper = (customToken) => {
  return signInWithCustomToken(auth, customToken);
};

// // Connect to auth emulator if in development
// if (import.meta.env.DEV) {
//     try {
//         connectAuthEmulator(auth, 'http://localhost:9099');
//         console.log('Connected to Firebase Auth Emulator');
//     } catch (error) {
//         console.warn('Failed to connect to Firebase Auth Emulator:', error);
//     }
// }

export default app; 